/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiSecurityRequirement } from '../../models/AaiSecurityRequirement';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends AaiSecurityRequirement
 * @author eric.wittmann@gmail.com
 */
export class Aai20SecurityRequirement extends AaiSecurityRequirement {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
Aai20SecurityRequirement["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20SecurityRequirement";
Aai20SecurityRequirement["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




